import React from 'react';
import { AUDIENCE_STUDIO } from '../../content';
import { KDSPageNames } from 'constants/index';
import {
  NavigationItem,
  NavigationItemLabel,
  NavigationWrapper,
} from './index.styles';
import { SupervisedUserCircleRounded } from '@material-ui/icons';
import { useRouteMatch } from 'react-router-dom';

const Navigation: React.FC = () => {
  const { url } = useRouteMatch();

  return (
    <NavigationWrapper>
      <NavigationItem to={`${url}/${KDSPageNames.AUDIENCESTUDIO}`}>
        <SupervisedUserCircleRounded style={{ color: 'white' }} />
        <NavigationItemLabel>{AUDIENCE_STUDIO}</NavigationItemLabel>
      </NavigationItem>
    </NavigationWrapper>
  );
};

export default Navigation;
